module.exports = __webpack_public_path__ + "img/list-svgrepo-com.4b607f2c.svg";